module.exports = __webpack_public_path__ + "img/map-marker-distance.1cf9d7c1.svg";